import { z } from "zod/v4";

export const AiPlanExperienceRequestMetadataSchema = z.object({
  version: z.string(),
});

export type AiPlanExperienceRequestMetadataType = z.infer<
  typeof AiPlanExperienceRequestMetadataSchema
>;
